import angular from 'angular'
import taxDeclarationConfigCtrl from './taxDeclarationConfigCtrl'
import taxDeclarationConfigEditCtrl from './taxDeclarationConfigEditCtrl'
import buildTaskDataFilterModal from './buildTaskDataFilterModal'

const listPage = require('./view/taxDeclarationConfig.html')
const addPage = require('./view/taxDeclarationConfigEdit.html')

function config($stateProvider) {
    $stateProvider
        .state('system.settingcenter.taxDeclarationConfig', {
            url: '/taxDeclarationConfig',
            template: '<div ui-view></div>',
            title: '纳税申报配置',
            abstract: true,
            default: 'system.settingcenter.taxDeclarationConfig.list',
        })
        .state('system.settingcenter.taxDeclarationConfig.list', {
            url: '/list',
            controller: 'taxDeclarationConfigCtrl',
            template: listPage,
        })
        .state('system.settingcenter.taxDeclarationConfig.add', {
            url: '/add',
            controller: 'taxDeclarationConfigEditCtrl',
            template: addPage,
            title: '新增',
        })
        .state('system.settingcenter.taxDeclarationConfig.edit', {
            url: '/edit/:id',
            controller: 'taxDeclarationConfigEditCtrl',
            template: addPage,
            title: '编辑',
        })
}
export default angular.module('system.settingcenter.taxDeclarationConfig', []).config(['$stateProvider', config]).controller('taxDeclarationConfigEditCtrl', taxDeclarationConfigEditCtrl).controller('buildTaskDataFilterModal', buildTaskDataFilterModal).controller('taxDeclarationConfigCtrl', taxDeclarationConfigCtrl).name



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/taxDeclarationConfig/index.js